import { useState } from "react";
import { X } from "lucide-react";

export default function TagInput({ value, onChange, placeholder, suggestions = [], testid }) {
  const [draft, setDraft] = useState("");
  const add = (t) => {
    const v = t.trim();
    if (v && !value.includes(v)) onChange([...value, v]);
    setDraft("");
  };
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };
  return (
    <div>
      <div className="input-paper flex flex-wrap gap-2 items-center min-h-[46px] !py-2">
        {value.map((t) => (
          <span key={t} className="stamp !shadow-none gap-1.5">
            {t}
            <button type="button" onClick={(e) => { e.preventDefault(); onChange(value.filter((x) => x !== t)); }} aria-label={`Remove ${t}`} data-testid={`${testid}-remove-${t.replace(/\s+/g, "-")}`}><X size={11} /></button>
          </span>
        ))}
        <input className="flex-1 min-w-[8rem] bg-transparent outline-none" value={draft} placeholder={value.length ? "" : placeholder}
          onChange={(e) => setDraft(e.target.value)} onKeyDown={onKey} onBlur={() => draft && add(draft)} data-testid={`${testid}-input`} />
      </div>
      {suggestions.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2.5">
          {suggestions.filter((s) => !value.includes(s)).map((s) => (
            <button type="button" key={s} onClick={(e) => { e.preventDefault(); add(s); }} className="font-type text-[0.65rem] uppercase tracking-wider text-[#8E8879] hover:text-[#C84B31] transition-colors" data-testid={`${testid}-suggest-${s.replace(/\s+/g, "-")}`}>+ {s}</button>
          ))}
        </div>
      )}
    </div>
  );
}
